import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { ProducersAutocompleteService } from './producers-autocomplete.service';
import { AuthenticationService } from '../../security/authentication.service';
import { ThirdParty } from '../../entity/third-party';
import { Subject } from 'rxjs/Subject';
import { ProducerAutocompleteSearchResult } from './producer-autocomplete-search-result';


const delayBeforeSearch = 500;
@Component({
    selector: 'app-producers-autocomplete',
    templateUrl: './producers-autocomplete.component.html',
    styleUrls: ['./producers-autocomplete.component.css']
})
export class ProducersAutocompleteComponent implements OnInit {
    @Input() preLoadedProducers: ThirdParty[];
    @Input() preSelectedProducer: ThirdParty;
    @Input() preFilledSearch: string;
    @Input() showNoProducerFoundAtStartApplicable: boolean;
    @Output() onProducerSelected: EventEmitter<ProducerAutocompleteSearchResult> = new EventEmitter<ProducerAutocompleteSearchResult>();
    @Output() onNewSearch: EventEmitter<ProducerAutocompleteSearchResult> = new EventEmitter<ProducerAutocompleteSearchResult>();
    searching: boolean;
    search: string;
    noProducerFoundMessageShowable: boolean;
    producers: ThirdParty[];
    selectedProducer: ThirdParty;
    private producerParentId: string;
    private debouncer: Subject<string> = new Subject();

    constructor(
        private producersAutocompleteService: ProducersAutocompleteService,
        private authenticationService: AuthenticationService
    ) {}

    ngOnInit(): void {
        this.noProducerFoundMessageShowable = !(this.showNoProducerFoundAtStartApplicable === undefined) ? this.showNoProducerFoundAtStartApplicable : false;
        this.producers = this.preLoadedProducers || [];
        this.search = this.preFilledSearch || null;
        this.selectedProducer = this.preSelectedProducer || null;
        this.debouncer
            .debounceTime(delayBeforeSearch)
            .subscribe(() => {
                this.fetchProducer();
            });
        this.searching = false;
        this.producerParentId = this.authenticationService.getCurrentUser().thirdParty.id;
    }

    fetchProducer() {
        this.searching = true;
        this.noProducerFoundMessageShowable = false;
        if (this.selectedProducer) {
            this.selectProducer(null);
        }
        this.producersAutocompleteService
            .searchProducers(this.search, this.producerParentId)
            .finally(() => {
                this.searching = false;
                this.noProducerFoundMessageShowable = true;
            })
            .subscribe((producers) => {
                this.producers = producers;
                this.onNewSearch.emit(new ProducerAutocompleteSearchResult(this.selectedProducer, this.producers, this.search));
            });
    }

    searchProducer() {
        if (this.search) {
            this.debouncer.next(this.search);
        }
    }

    selectProducer(producer: ThirdParty) {
        if (producer && this.selectedProducer && this.selectedProducer.id === producer.id) {
            this.selectedProducer = null;
        } else {
            this.selectedProducer = producer;
        }
        this.onProducerSelected.emit(new ProducerAutocompleteSearchResult(this.selectedProducer, this.producers, this.search));
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/producers/producers-autocomplete.component.ts